import React, { useState, useEffect } from "react";
import bike from "../Assets/bike6.png";
import bike2 from "../Assets/bike2.png";
import bike3 from "../Assets/bike3.png";
import bike4 from "../Assets/bike4.png";
import { FaArrowLeft, FaArrowRight } from "react-icons/fa";

const bikes = [bike, bike2, bike3, bike4];
const bikeLabels = ["Sport Series", "Cruiser Edition", "Street Fighter", "Adventure Pro"];

const Home = ({ onOpenModal }) => {
  const [current, setCurrent] = useState(0);
  const [animating, setAnimating] = useState(false);

  useEffect(() => {
    const interval = setInterval(() => {
      goNext();
    }, 3500);
    return () => clearInterval(interval);
  }, [current]);

  const goTo = (i) => {
    if (i === current || animating) return;
    setAnimating(true);
    setTimeout(() => {
      setCurrent(i);
      setAnimating(false);
    }, 300);
  };

  const goNext = () => goTo((current + 1) % bikes.length);
  const goPrev = () => goTo((current - 1 + bikes.length) % bikes.length);

  return (
    <>
      <style>{`
        /* ── FONT CHANGE: Oswald (display) + DM Sans (body) ── */
        @import url('https://fonts.googleapis.com/css2?family=Oswald:wght@400;500;600;700&family=DM+Sans:wght@400;500;600&family=Barlow+Condensed:wght@400;600;700;800&display=swap');

        .font-bebas       { font-family: 'Oswald', sans-serif; letter-spacing: 0.02em; }
        .font-barlow      { font-family: 'DM Sans', sans-serif; }
        .font-barlow-cond { font-family: 'Barlow Condensed', sans-serif; }

        .hero-grid-bg {
          background-image:
            linear-gradient(rgba(212,175,55,0.04) 1px, transparent 1px),
            linear-gradient(90deg, rgba(212,175,55,0.04) 1px, transparent 1px);
          background-size: 56px 56px;
          animation: gridDrift 24s linear infinite;
        }
        @keyframes gridDrift {
          from { background-position: 0 0; }
          to   { background-position: 56px 56px; }
        }

        .orbit-ring {
          border: 1px solid rgba(212,175,55,0.15);
          border-radius: 50%;
          animation: orbitSpin 14s linear infinite;
          position: absolute;
        }
        .orbit-ring::before {
          content: '';
          position: absolute;
          top: -4px; left: 50%;
          transform: translateX(-50%);
          width: 8px; height: 8px;
          border-radius: 50%;
          background: #D4AF37;
          box-shadow: 0 0 8px #D4AF37;
        }
        .orbit-ring-2 {
          animation-direction: reverse;
          animation-duration: 20s;
          border-color: rgba(212,175,55,0.08);
        }
        @keyframes orbitSpin {
          from { transform: translate(-50%,-50%) rotate(0deg); }
          to   { transform: translate(-50%,-50%) rotate(360deg); }
        }

        .bike-float {
          animation: bikeFloat 4s ease-in-out infinite;
          filter: drop-shadow(0 30px 70px rgba(212,175,55,0.35));
        }
        @keyframes bikeFloat {
          0%,100% { transform: translateY(0px)   rotate(-0.5deg); }
          50%      { transform: translateY(-20px) rotate( 0.5deg); }
        }

        .bike-glow {
          background: radial-gradient(circle, rgba(212,175,55,0.22) 0%, transparent 70%);
          animation: glowBreath 3.5s ease-in-out infinite;
        }
        @keyframes glowBreath {
          0%,100% { transform: scale(1);   opacity: 0.7; }
          50%      { transform: scale(1.2); opacity: 1;   }
        }

        .bike-img { transition: opacity 0.3s ease, transform 0.3s ease; }
        .bike-img.out { opacity: 0; transform: translateX(30px) scale(0.95); }

        .text-stroke {
          -webkit-text-stroke: 1.5px #F5F5F5;
          color: transparent;
        }

        .btn-slash {
          clip-path: polygon(0 0, calc(100% - 12px) 0, 100% 50%, calc(100% - 12px) 100%, 0 100%);
        }

        .stat-sep {
          width: 1px; height: 36px;
          background: linear-gradient(to bottom, transparent, rgba(212,175,55,0.4), transparent);
        }

        @keyframes fadeUp {
          from { opacity: 0; transform: translateY(28px); }
          to   { opacity: 1; transform: translateY(0); }
        }
        .fade-up  { animation: fadeUp 0.8s ease forwards; }
        .delay-1  { animation-delay: 0.10s; opacity: 0; }
        .delay-2  { animation-delay: 0.25s; opacity: 0; }
        .delay-3  { animation-delay: 0.40s; opacity: 0; }
        .delay-4  { animation-delay: 0.55s; opacity: 0; }
        .delay-5  { animation-delay: 0.70s; opacity: 0; }

        .scroll-line { animation: scrollDown 1.5s ease-in-out infinite; }
        @keyframes scrollDown {
          0%   { transform: scaleY(0); transform-origin: top; }
          50%  { transform: scaleY(1); transform-origin: top; }
          51%  { transform: scaleY(1); transform-origin: bottom; }
          100% { transform: scaleY(0); transform-origin: bottom; }
        }

        .slide-arrow { transition: background 0.2s, border-color 0.2s; }
        .slide-arrow:hover {
          background: #D4AF37 !important;
          border-color: #D4AF37 !important;
          color: white !important;
        }
      `}</style>

      <section id="home" className="relative w-full bg-[#050505] overflow-hidden flex items-center" style={{ paddingTop: 80 }}>

        {/* Grid background */}
        <div className="hero-grid-bg absolute inset-0 z-0" />

        {/* Right dark-red diagonal panel */}
        <div
          className="absolute top-0 right-0 w-[55%] h-full z-0"
          style={{
            background: "linear-gradient(160deg, #180000 0%, #0d0000 100%)",
            clipPath: "polygon(8% 0, 100% 0, 100% 100%, 0% 100%)",
          }}
        />

        {/* Noise texture */}
        <div
          className="absolute inset-0 z-0 pointer-events-none opacity-30"
          style={{
            backgroundImage: `url("data:image/svg+xml,%3Csvg viewBox='0 0 256 256' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='4' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)' opacity='0.05'/%3E%3C/svg%3E")`,
          }}
        />

        {/* CONTENT GRID */}
        <div className="relative z-10 w-full h-full grid grid-cols-1 lg:grid-cols-2">

          {/* ── LEFT ── */}
          <div className="flex flex-col justify-center px-6 md:px-28 py-6">

            {/* Eyebrow label */}
            <div className="fade-up delay-1 flex items-center gap-3 mb-4 font-barlow-cond text-[11px] tracking-[4px] uppercase text-[#D4AF37]">
              <span className="w-8 h-px bg-[#D4AF37]" />
              Premium Motorcycles · Katpadi
            </div>

            {/* Hero heading — Oswald replaces Bebas */}
            <h1 className="fade-up delay-2 font-bebas leading-[0.95] mb-5" style={{ fontSize: "clamp(52px, 7.5vw, 104px)" }}>
              <span className="block text-stroke">Ride</span>
              <span className="block text-[#D4AF37]">Beyond</span>
              <span className="block text-[#F5F5F5]">Limits</span>
            </h1>

            {/* Paragraph — larger, brighter */}
            <p className="fade-up delay-3 font-barlow text-[#9CA3AF] text-[16px] leading-[1.8] max-w-[380px] mb-7">
              Power. Precision. Pure adrenaline. Find your perfect machine at Sri Kalikambal Autos — where every legendary ride begins.
            </p>

            <div className="fade-up delay-4 flex flex-wrap items-center gap-4 mb-8">
              <button onClick={onOpenModal} className="btn-slash flex items-center gap-3 bg-[#D4AF37] hover:bg-[#E5C158] text-white pl-6 pr-4 py-3 font-barlow-cond text-[13px] font-bold tracking-[2px] uppercase transition-colors duration-300">
                Book Test Ride
                <div className="w-8 h-8 bg-black/20 flex items-center justify-center text-base"><FaArrowRight /></div>
              </button>
              <button className="font-barlow-cond text-[13px] tracking-[2px] uppercase text-[#9CA3AF] border border-[#D4AF37]/25 px-6 py-3 hover:border-[#D4AF37] hover:text-[#F5F5F5] transition-all duration-300">
                Explore Bikes
              </button>
            </div>

            {/* Stats */}
            <div className="fade-up delay-5 flex items-center gap-8 pt-6 border-t border-white/[0.06]">
              {[
                { num: "500+", label: "Bikes Sold" },
                { num: "20+",  label: "Years Trust" },
                { num: "4.9★", label: "Rating" },
              ].map((s, i) => (
                <React.Fragment key={s.label}>
                  {i > 0 && <div className="stat-sep" />}
                  <div className="flex flex-col gap-1">
                    <span className="font-bebas text-[30px] text-[#D4AF37] leading-none">{s.num}</span>
                    <span className="font-barlow-cond text-[10px] tracking-[3px] uppercase text-[#666]">{s.label}</span>
                  </div>
                </React.Fragment>
              ))}
            </div>
          </div>

          {/* ── RIGHT — BIKE STAGE ── */}
          <div className="relative flex flex-col items-center justify-center py-4">

            <span
              className="absolute top-1/2 right-6 -translate-y-1/2 font-bebas text-[#D4AF37]/5 pointer-events-none select-none"
              style={{ fontSize: "clamp(80px, 12vw, 150px)" }}
            >
              {String(current + 1).padStart(2, "0")}
            </span>

            <div className="relative flex items-center justify-center w-full" style={{ maxWidth: 700 }}>
              <div className="bike-glow absolute rounded-full" style={{ width: 440, height: 440 }} />
              <div className="orbit-ring absolute" style={{ width: 500, height: 500, top: "50%", left: "50%" }} />
              <div className="orbit-ring orbit-ring-2 absolute" style={{ width: 620, height: 620, top: "50%", left: "50%" }} />

              <div className="relative z-10 w-full px-2">
                <img
                  src={bikes[current]}
                  alt={bikeLabels[current]}
                  className={`bike-float bike-img w-full object-contain ${animating ? "out" : ""}`}
                  style={{ maxHeight: "70vh", minHeight: 260 }}
                />
              </div>

              <div
                className="absolute bottom-0 left-1/2 -translate-x-1/2 h-[2px] w-4/5 rounded-full"
                style={{ background: "linear-gradient(to right, transparent, rgba(212,175,55,0.5), transparent)" }}
              />
            </div>

            {/* Bike label */}
            <div className="mt-3 font-barlow-cond text-[11px] tracking-[4px] uppercase text-[#D4AF37] text-center">
              {bikeLabels[current]}
            </div>

            {/* Slide controls */}
            <div className="flex items-center gap-5 mt-3">
              <button onClick={goPrev} className="slide-arrow w-9 h-9 border border-white/10 text-[#666] flex items-center justify-center font-bold"><FaArrowLeft /></button>
              <div className="flex gap-2">
                {bikes.map((_, i) => (
                  <button
                    className="transition-all duration-300"
                    onClick={() => goTo(i)}
                    key={i}
                    style={{
                      height: 4,
                      width: i === current ? 28 : 8,
                      borderRadius: 2,
                      background: i === current ? "#D4AF37" : "rgba(255,255,255,0.15)",
                    }}
                  />
                ))}
              </div>
              <button onClick={goNext} className="slide-arrow w-9 h-9 border border-white/10 text-[#666] flex items-center justify-center font-bold"><FaArrowRight /></button>
            </div>
          </div>
        </div>

        {/* Scroll indicator */}
        <div className="absolute bottom-5 left-12 flex flex-col items-center gap-2 z-10">
          <div className="w-px h-10 bg-[#D4AF37]/20 relative overflow-hidden">
            <div className="scroll-line absolute inset-0 bg-[#D4AF37]" />
          </div>
          <span className="font-barlow-cond text-[9px] tracking-[3px] uppercase text-[#444]" style={{ writingMode: "vertical-rl" }}>Scroll</span>
        </div>
      </section>
    </>
  );
};

export default Home;